module.exports = __webpack_public_path__ + "static/img/20141221_0365_1920x1440.c312b4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/20141221_0365_1920x1440.jpg
// module id = Cxzh
// module chunks = 1